module.exports = __webpack_public_path__ + "static/process4-0a9e3c3a4a8755d3d9234bc1c38fec81.png";